import "rxjs"
import $ from "jquery"
import {ajax} from "rxjs/observable/dom/ajax"
import config from "../config"
import {
  ACTION_SHOW_LICENSE_ERROR,
  ACTION_SHOW_LICENSE_LOADING,
  ACTION_SHOW_LICENSE_LOADED,
  PATH_LICENSES
} from "../constants"

const api_server_host = config.api_server_host

const errorHandler = (data) => {
  const action = {
    type: ACTION_SHOW_LICENSE_ERROR,
    payload: data
  }
  return Observable.of(action)
}

const epic = (action$, store)=>
  action$.ofType(ACTION_SHOW_LICENSE_LOADING)
    .mergeMap(action => {


      const tokenData = store.getState().user
      const token = tokenData.access_token
      const type = tokenData.token_type

      const id = action.payload

      return ajax({
        method: 'GET',
        url: `${api_server_host}${PATH_LICENSES}/${id}`,
        headers: {
          Authorization: `${type} ${token}`
        },
        responseType: 'json'
      }).map(data=> {
        return {
          type: ACTION_SHOW_LICENSE_LOADED,
          payload: data.response
        }
      }).catch(errorHandler)

    })

export default epic



// WEBPACK FOOTER //
// ./src/epics/ShowLicenseEpic.js